import { ResourceSectionType } from 'frontend/common/layout/enum/resource-section-type'
import { ISidebarNavigationSectionItem } from 'frontend/common/layout/types/i-sidebar-navigation-section-item'

export const SidebarNavigationSectionItems: ISidebarNavigationSectionItem[] = [
  {
    sectionType: ResourceSectionType.OperationalModules,
    name: 'Operational Modules',
  },
  {
    sectionType: ResourceSectionType.Demand,
    name: 'Demand',
  },
  {
    sectionType: ResourceSectionType.Resources,
    name: 'Resources',
  },
  {
    sectionType: ResourceSectionType.Places,
    name: 'Places',
  },
  {
    sectionType: ResourceSectionType.Settings,
    name: 'Settings',
  },
]
